import { type ElementType, type ReactElement, SubmitEvent } from "react";

import { cx, styled } from "simplydo/react/styled";

import { StyledForm } from "./Form.styles";
import type { FormProps } from "./Form.types";

const FormComponent = (props: FormProps): ReactElement => {
  const {
    as,
    children,
    className,
    style,
    error,
    inverted,
    loading,
    size,
    success,
    warning,
    widths,
    onSubmit,
  } = props;

  const Component = (as || "form") as ElementType;

  const handleSubmit = (event: SubmitEvent<HTMLFormElement>) => {
    if (onSubmit) {
      event.preventDefault();
      onSubmit(event, props);
    }
  };

  return (
    <StyledForm
      as={Component}
      className={cx(
        className,
        error && "is-error",
        success && "is-success",
        warning && "is-warning",
        inverted && "is-inverted",
        loading && "is-loading",
        widths === "equal" && "is-equal-width",
        size,
      )}
      style={style}
      $size={size}
      onSubmit={handleSubmit}
    >
      {children}
    </StyledForm>
  );
};

export const Form = styled(FormComponent)``;
